module.exports = __webpack_public_path__ + "static/media/check.6e0f9397.svg";